// react-apexcharts' bundled UMD/iife build is invoked as
//   }(ApexCharts, React, PropTypes)
// i.e. it reads three globals — ApexCharts, React and PropTypes — off the
// window. CRA's webpack does not provide them, so the app crashes at
// module-init with "<name> is not defined" before any component renders.
// Exposing all three here — and importing this module FIRST in index.js —
// guarantees the globals exist before the rest of the module graph (which
// pulls in react-apexcharts) is evaluated.
import React from "react";
import ApexCharts from "apexcharts";
import PropTypes from "prop-types";

if (typeof window !== "undefined") {
  if (!window.React) window.React = React;
  if (!window.ApexCharts) window.ApexCharts = ApexCharts;
  if (!window.PropTypes) window.PropTypes = PropTypes;
}
